(ns ui.state.time.cofx
  "Coeffects for time-derived values. Reading the clock lives here, not in event
   handlers, so handler computations stay pure/replayable.

   `today-utc-midnight-ms` is a CALENDAR DAY (the local day, pinned to UTC
   midnight as date fields are stored), deliberately distinct from `now` (a
   precise instant). Don't conflate the two."
  (:require
   [re-frame.core :as rf]))

(defn today-utc-midnight-ms
  "The current local calendar day at UTC midnight, as epoch ms."
  []
  (let [d (js/Date.)]
    (js/Date.UTC (.getFullYear d) (.getMonth d) (.getDate d))))

(rf/reg-cofx
 ::today-utc-midnight-ms
 (fn [coeffects]
   (assoc coeffects :today-utc-midnight-ms (today-utc-midnight-ms))))
